<template>
  <div id="app"  v-loading="loading"  element-loading-background="rgba(255, 255, 255, 0.96)">
    <!-- 根路由出口，用于渲染路由组件 -->
    <router-view />
  </div>
</template>

<script>
export default {
  data(){
    return {
      loading:false,
      isFirstLogin:false
    }
  },
  methods:{
    reflech(){
      this.loading = true;
      setTimeout(() => {
        this.loading=false;
        return 'stop'
      }, 1000);
    },
    setFirstLogin(){
      //首次渲染，设置为首次登录状态。
      this.isFirstLogin = true;
    },
    firfun(){
      //判断是否是首次登录
      return this.isFirstLogin
    },
    setnoFirstLogin(){
      this.isFirstLogin = false;
    },
    hasbtn(btnname){ //fdsasdsxsswwffdasdaw
 return true
 //return  this.$route.meta[1].includes(btnname)// 正式开启
    }
  },
  created(){
    this.$root.$firfun = this.firfun;
    this.$root.$setFirstLogin = this.setFirstLogin
    this.$root.$setnoFirstLogin = this.setnoFirstLogin
    this.$root.$reflech =  this.reflech;
    this.$root.$hasbtn =  this.hasbtn;

    //  // 限制浏览器不准缩放
    //  window.addEventListener(
    //   "mousewheel",
    //   function (event) {
    //     if (event.ctrlKey === true || event.metaKey) {
    //       event.preventDefault();
    //     }
    //   },
    //   { passive: false }
    // );

    // //firefox
    // window.addEventListener(
    //   "DOMMouseScroll",
    //   function (event) {
    //     if (event.ctrlKey === true || event.metaKey) {
    //       event.preventDefault();
    //     }
    //   },
    //   { passive: false }
    // );
    //  this.$confirm("新考核云已启用新域名http://newkhy.tibosi.com，本地址将于2022年6月17日停止运行，请保存/收藏新域名。","温馨提示",{
    //       confirmButtonText: "立即前往",
    //       showClose:false,
    //       showCancelButton:false,
    //       closeOnClickModal:false,
    //       closeOnPressEscape:false,
    //       closeOnHashChange:false,
    //       type: "warning",
    //   }).then(() => {
    //      window.location.href='http://newkhy.tibosi.com'
    //   });
  }
}
</script>
<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
